import { render } from "./MetOceanPlots.vue?vue&type=template&id=67d05cca"
import script from "./MetOceanPlots.vue?vue&type=script&lang=js"
export * from "./MetOceanPlots.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__